import React from "react";
import {FIELD_TYPE, TT_PHIEU_VTYT} from "types/enums";
import {ColumnProps} from "types/models";
import {formatDateToString, formatToCurrencyTypeFloor} from "helper/common";
import {listNguonVTYT, listTTPhieuVTYT} from "data/list";
import {Tooltip, Typography} from "antd";

const {INPUT, CODE, DATE_DISABLE, COMBO_BOX} = FIELD_TYPE;

const allColumns: ColumnProps[] = [
  {
    key: "index",
    title: "STT",
    show: true,
    isResizable: true,
    dataIndex: "index",
    render(value, record, index) {
      return <>{index + 1}</>;
    },
    width: 50,
    fixed: "left",
    align: "center",
  },
  {
    title: "Mã phiếu",
    key: "id",
    show: true,
    isResizable: true,
    dataIndex: "id",
    width: 80,
    align: "center",
  },
  {
    title: "Kho nhập",
    key: "khoNhap",
    show: true,
    isResizable: true,
    width: 150,
    dataIndex: "khoNhap",
  },
  {
    title: "Kho xuất",
    key: "khoXuat",
    show: true,
    isResizable: true,
    dataIndex: "khoXuat",
    width: 150,
  },
  {
    title: "Tiêu đề phiếu",
    key: "tieuDe",
    show: false,
    isResizable: true,
    dataIndex: "tieuDe",
    width: 150,
    render: text => (
      <Tooltip title={text} placement="top" arrow={false}>
        <Typography.Text ellipsis={true}>{text}</Typography.Text>
      </Tooltip>
    ),
  },
  {
    title: "Số hóa đơn",
    key: "soHoaDon",
    show: false,
    isResizable: true,
    dataIndex: "soHoaDon",
    width: 120,
  },
  {
    title: "Nguồn VTYT",
    key: "nguonVTYT",
    show: false,
    isResizable: true,
    width: 150,
    dataIndex: "nguonVTYT",
  },
  {
    title: "Trạng thái phiếu",
    key: "tinhTrang",
    width: 120,
    show: true,
    isResizable: true,
    dataIndex: "tinhTrang",
    render(value) {
      switch (value) {
        case TT_PHIEU_VTYT.NHAP:
          return "Nháp";
        case TT_PHIEU_VTYT.CHO_DUYET:
          return "Chờ duyệt";
        case TT_PHIEU_VTYT.CANH_BAO:
          return "Đã duyệt";
        case TT_PHIEU_VTYT.HOAN_THANH:
          return "Hoàn thành";
        case TT_PHIEU_VTYT.TU_CHOI:
          return "Từ chối";
        case TT_PHIEU_VTYT.HUY:
          return "Hủy";
        default:
          break;
      }
    },
  },
  {
    title: "Ngày lập phiếu",
    width: 120,
    key: "createDate",
    show: false,
    isResizable: true,
    dataIndex: "createDate",
    render(value) {
      return <>{value ? formatDateToString(value) : null}</>;
    },
  },
  {
    title: "Ngày hóa đơn",
    key: "ngayHoaDon",
    width: 120,
    show: false,
    isResizable: true,
    dataIndex: "ngayHoaDon",
    render(value) {
      return <>{value ? formatDateToString(value) : null}</>;
    },
  },

  {
    title: "Người lập phiếu",
    key: "nguoiLap",
    show: false,
    isResizable: true,
    width: 150,
    dataIndex: "nguoiLap",
  },
  {
    title: "Người giao",
    key: "nguoiGiao",
    show: false,
    isResizable: true,
    dataIndex: "nguoiGiao",
    width: 150,
  },
  {
    title: "Người nhận",
    key: "nguoiNhan",
    show: false,
    isResizable: true,
    dataIndex: "nguoiNhan",
    width: 150,
  },
  {
    title: "Ngày dự trù",
    key: "ngayDuTru",
    show: false,
    isResizable: true,
    dataIndex: "ngayDuTru",
    width: 150,
  },
  {
    title: "Ngày hoàn thành nhập",
    key: "ngayHoanThanh",
    width: 120,
    show: true,
    isResizable: true,
    align: "center",
    dataIndex: "ngayHoanThanh",
    render(value) {
      return <>{value ? formatDateToString(value) : null}</>;
    },
  },
  {
    title: "Tổng giá trị",
    key: "tongGiaTri",
    show: true,
    isResizable: true,
    dataIndex: "tongGiaTri",
    width: 150,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyTypeFloor(value)}</>;
    },
  },
  {
    title: "Ghi chú",
    key: "ghiChu",
    show: true,
    isResizable: true,
    width: 200,
    dataIndex: "ghiChu",
    render: text => (
      <Tooltip title={text} placement="top" arrow={false}>
        <Typography.Text ellipsis={true}>{text}</Typography.Text>
      </Tooltip>
    ),
  },
  {
    title: "Mã phiếu tham chiếu",
    key: "phieuThamChieuId",
    show: false,
    isResizable: true,
    dataIndex: "phieuThamChieuId",
    width: 150,
  },
];

const inputFields: any[] = [
  {
    type: INPUT,
    name: "id",
    label: "Mã phiếu",
  },
  {
    type: INPUT,
    name: "tieuDe",
    label: "Tiêu đề phiếu",
  },
  {
    type: COMBO_BOX,
    name: "khoNhapId",
    label: "Kho nhập",
  },
  {
    type: COMBO_BOX,
    name: "khoXuatId",
    label: "Kho xuất",
  },
  {
    type: COMBO_BOX,
    label: "Nguồn VTYT",
    name: "nguonVTYTId",
  },
  {
    type: COMBO_BOX,
    name: "tinhTrang",
    label: "Tình trạng",
    options: listTTPhieuVTYT,
  },
  {
    type: DATE_DISABLE,
    name: "start",
    label: "Từ ngày",
  },
  {
    type: DATE_DISABLE,
    name: "end",
    label: "Đến ngày",
  },
];

export {allColumns, inputFields};
